/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type Format = typeof Format[keyof typeof Format];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Format = {
  json: 'json',
  csv: 'csv',
} as const;
